<template>
  <div class="login-content__login">
    <b-row>
      <b-col cols="6" offset="3" md="5" offset-md="0">
        <img class="log__img" src="~assets/ico-person.svg" alt="">
      </b-col>
      <b-col md="7" class="mt-3 mt-md-0">
        <h1 class="text--black">Hello, friend</h1>
        <span class="log__text text--capitalize">{{ userType }}</span>
        <b-form id="loginForm" @submit.prevent="logIn">
            <b-form-input
              type="email"
              v-model="user.email"
              required placeholder="User email"
              :state="errors.length !== 0 ? false : null"
              aria-describedby="inputLiveFeedback"
              class="mb-3">
            </b-form-input>
            <div class="log__input">
              <b-form-input
                v-model="user.password"
                :type="passowordType"
                required placeholder="Enter password"
                :state="errors.length !== 0 ? false : null"
                aria-describedby="inputLiveFeedback"
                class="mb-3">
              </b-form-input>
              <div class="log__password-visible">
                <div>
                  <i v-if="passowordType === 'password'"
                    @click.prevent.stop="passowordType = 'text'" class="fas fa-eye"></i>
                  <i v-else @click.prevent.stop="passowordType = 'password'"
                  class="fas fa-eye-slash"></i>
                </div>
              </div>
            </div>
            <b-form-invalid-feedback id="inputLiveFeedback">
              <span v-for="(error, index) in errors" :key="index">{{ error }}</span>
            </b-form-invalid-feedback>
        </b-form>
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-col md="4" class="col-xl-3">
        <div class="d-flex flex-column align-items-center">
          <b-btn variant="primary" size="sm" class="button--margin"
            type="submit" form="loginForm">
            {{ $t("auth.logIn") }}
          </b-btn>

          <slot name="createAccount"></slot>

          <button class="log__password" @click="forgotPassword" :disabled="isLoading">
            {{ $t("auth.password") }}
          </button>
          <span v-if="succes" class="log__succes">
            {{ $t("auth.link") }}
          </span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import auth from '@/api/v1/auth';

export default {
  props: ['userType'],
  data() {
    return {
      user: {},
      errors: [],
      succes: false,
      passowordType: 'password',
      isLoading: false,
    };
  },
  methods: {
    logIn() {
      const err = (error) => {
        this.user.password = '';
        const errors = error.response.data.errors;
        if (errors && errors.confirmation) {
          this.errors = errors.confirmation;
        } else {
          this.errors = ['Something went wrong'];
        }
      };
      auth.logIn(this.userType, this.user, err);
    },
    forgotPassword() {
      this.isLoading = true;
      const url = `${process.env.SITE_DOMAIN}password_reset`;
      if (this.user.email) {
        const succ = () => {
          this.succes = true;
          this.isLoading = false;
        };
        const err = (error) => {
          this.user.password = '';
          this.errors = error.response.data.errors;
          this.isLoading = false;
        };
        auth.forgotPassword(url, this.user.email, succ, err);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Auth/Login/Form.vue